import React from "react";

export interface ImageContainerProps {
  image: any;
}

const ImageContainer: React.FC<ImageContainerProps> = ({ image }) => (
  <img src={image} alt="image-container" />
);

export default ImageContainer;
